import React, { useState, useEffect } from 'react';
import { Flex, Box, useBreakpointValue } from '@chakra-ui/react';
import { SwiperSlide } from 'swiper/react';
import Wrapper from '@components/atoms/Wrapper';
import Button from '@components/atoms/Button';
import Title from '@components/atoms/Title';
import HeaderFont from '@components/atoms/HeaderFont';
import { FiChevronLeft } from '@react-icons/all-files/fi/FiChevronLeft';
import { FiChevronRight } from '@react-icons/all-files/fi/FiChevronRight';
import ReviewCard from '@components/molecules/ReviewCard';
import Slideshow from '@components/molecules/Slideshow';
import RichText from '@components/atoms/RichText';

const ReviewCarousel = ({
  data = {
    title: ``,
    reviewItems: [],
    disclaimer: {}
  }
}) => {
  const { title, disclaimer, reviewItems } = data;

  const isDesktop = useBreakpointValue({ md: false, lg: true });
  const isTablet = useBreakpointValue({ sm: false, md: true });
  const isMobile = useBreakpointValue({ base: false, sm: true });

  const [slidesPerView, setSlidesPerView] = useState(1);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [slideNumber] = useState(reviewItems.length);

  const handleOnSlideChange = ({ activeIndex }) => setCurrentSlide(activeIndex);

  useEffect(() => {
    setSlidesPerView(1);

    if (isMobile) {
      setSlidesPerView(1.5);
    }

    if (isTablet) {
      setSlidesPerView(2.5);
    }

    if (isDesktop) {
      setSlidesPerView(3);
    }
  }, [isDesktop, isTablet, isMobile, slidesPerView]);

  return (
    <Flex direction="column" overflow="hidden" pb={{ base: `14`, md: `16` }}>
      <Wrapper>
        <Title
          as="h3"
          pb="2.313rem"
          color="purple.600"
          fontWeight="900"
          fontSize={{ base: `4xl`, md: `5xl` }}
          fontStyle="italic"
          textTransform="uppercase"
          lineHeight={{ base: `2.688rem`, md: `3rem` }}>
          <HeaderFont>{title}</HeaderFont>
        </Title>
        <Box>
          <Slideshow
            useExternalBreakpoints
            slidesPerView={slidesPerView}
            navProps={{
              prevEl: `.prev`,
              nextEl: `.next`
            }}
            sliderStyles={{
              overflow: `visible`
            }}
            onSlideChange={handleOnSlideChange}>
            {reviewItems.map((item) => {
              return (
                <SwiperSlide key={item.id}>
                  <ReviewCard data={item} />
                </SwiperSlide>
              );
            })}
          </Slideshow>
        </Box>
        <Box
          pt="1.688rem"
          pos="relative"
          sx={{
            p: {
              m: `0`
            }
          }}>
          <Box color="gray.600" fontSize="xs" fontWeight="400">
            <RichText data={disclaimer?.data?.disclaimer} />
          </Box>
          <Box pos="absolute" right="0" bottom="0">
            <Button
              className="prev"
              mr="0.25rem"
              p="0"
              minHeight="0"
              boxShadow="lg"
              rounded="100px"
              bg="transparent"
              borderColor="purple.50"
              borderWidth="1px"
              style={{
                opacity: currentSlide <= 0 || !isDesktop ? `0` : `1`
              }}>
              <Box pos="relative" zIndex="2" color="black">
                <FiChevronLeft fontSize="1rem" bg="transparent" />
              </Box>
            </Button>
            <Button
              className="next"
              ml="0.25rem"
              p="0"
              minHeight="0"
              boxShadow="lg"
              rounded="100px"
              bg="transparent"
              borderColor="purple.50"
              borderWidth="1px"
              style={{
                opacity:
                  currentSlide + slidesPerView >= slideNumber || !isDesktop
                    ? `0`
                    : `1`
              }}>
              <Box pos="relative" zIndex="2" color="black">
                <FiChevronRight fontSize="1rem" bg="transparent" />
              </Box>
            </Button>
          </Box>
        </Box>
      </Wrapper>
    </Flex>
  );
};

export default ReviewCarousel;
